import { render, staticRenderFns } from "./ShortVideoModule.vue?vue&type=template&id=ebe6ba1a&scoped=true"
import script from "./ShortVideoModule.vue?vue&type=script&lang=js"
export * from "./ShortVideoModule.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoModule.vue?vue&type=style&index=0&id=ebe6ba1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe6ba1a",
  null
  
)

export default component.exports